import { ActionIcon, Popover, Table, Box } from '@mantine/core'
import { IconEye } from '@tabler/icons-react'
import React, { useState } from 'react'

const ProductsCell = (row) => {
    const [opened, setOpened] = useState(false);
    
    const renderChildren = (items) => {
        const productsToDisplay = items?.row?.groupedItems || items?.row?.items;
        if (!productsToDisplay || productsToDisplay.length < 1) return <Box p="sm">No products available</Box>;

        const rows = productsToDisplay.map((item, index) => (
            <Table.Tr key={index}>
                <Table.Td style={{ backgroundColor: '#d08d8dff' }}>
                    {item?.productVariant?.variantSku}
                </Table.Td>
                <Table.Td style={{ backgroundColor: '#d08d8dff' }}>
                    {item?.productVariant?.name || "Item Name Not Available"}
                </Table.Td>
                <Table.Td style={{ backgroundColor: '#d08d8dff' }}>
                    {(item?.uom)?.toUpperCase()}
                </Table.Td>
                <Table.Td style={{ backgroundColor: '#d08d8dff' }}>
                    {Math?.ceil(item?.orderedRolls)}
                </Table.Td>
                <Table.Td style={{ backgroundColor: '#d08d8dff' }}>
                    {Math?.round(item?.qty)}
                </Table.Td>
            </Table.Tr>
        ));

        const headers = ["Variant Sku", "Variant Name", "Uom", "Roll", "Qty"];

        return (
            <Box style={{ overflowX: 'auto', maxWidth: '100vw' }}>
                <Table
                    striped
                    highlightOnHover
                    withColumnBorders
                    withTableBorder
                    style={{ border: "1px solid #d08d8dff", minWidth: "400px" }}
                >
                    <Table.Thead>
                        <Table.Tr>
                            {headers.map((header, index) => (
                                <Table.Th key={index} style={{ border: "1px solid #423a3a3a", backgroundColor: "lightgray", whiteSpace: "nowrap" }}>
                                    {header}
                                </Table.Th>
                            ))}
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {rows.map((row, rowIndex) => (
                            <Table.Tr key={rowIndex}>
                                {row.props.children.map((cell, cellIndex) => (
                                    <Table.Td key={cellIndex} style={{ border: "1px solid #423a3a3a", textAlign: "center", verticalAlign: "middle" }}>
                                        {cell.props.children}
                                    </Table.Td>
                                ))}
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            </Box>
        );
    };

    return (
        <Popover
            opened={opened}
            onChange={setOpened}
            position="bottom"
            withArrow
            shadow="md"
            middlewares={{ flip: true, shift: true, inline: true }}
            styles={{
                dropdown: {
                    padding: 0,
                    maxWidth: '95vw'
                },
            }}
        >
            <Popover.Target>
                <ActionIcon
                    color="#2b2525ff"
                    variant="light"
                    onClick={() => setOpened((o) => !o)}
                    title="View Products"
                >
                    <IconEye size={18} />
                </ActionIcon>
            </Popover.Target>

            <Popover.Dropdown>
                {renderChildren(row)}
            </Popover.Dropdown>
        </Popover>
    );
};

export default ProductsCell
